{
  "name": "@ns/company-turnover-confirmed-notice",
  "version": "1.0.0",
  "description": "Let the user know the turnover figure they disputed matches their current Companies House record.",
  "inputs": {},
  "outcomes": {
    "complete": {}
  }
}
